const getUniversalValue = (periodStr) => {
    const str = String(periodStr).trim();
    
    const matchWeek = str.match(/^(\d{2})-Sem-(\d{1,2})$/);
    if (matchWeek) {
      const year = parseInt(matchWeek[1]) + 2000;
      const week = parseInt(matchWeek[2]);
      return year * 1000 + week;
    }
    
    const matchYear = str.match(/^(\d{4})$/);
    if (matchYear) {
      return parseInt(matchYear[1]) * 1000;
    }
    
    const matchMonth = str.match(/^(\d{2})[-.](\d{1,2})[-.][A-Za-z]{3}/);
    if (matchMonth) {
      const year = parseInt(matchMonth[1]) + 2000;
      const month = parseInt(matchMonth[2]);
      return year * 100 + month;
    }
    
    const matchMonthAlt = str.match(/^(\d{4})[-.](\d{1,2})$/);
    if (matchMonthAlt) {
      const year = parseInt(matchMonthAlt[1]);
      const month = parseInt(matchMonthAlt[2]);
      return year * 100 + month;
    }
    
    return 99999999;
};
  
export const orderByPeriods = (data, field = 'Periodo', asc = true) => {
    return [...data].sort((a, b) => {
      const valueA = getUniversalValue(a[field]);
      const valueB = getUniversalValue(b[field]);
      
      return asc ? valueA - valueB : valueB - valueA;
    });
};